import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import axios from "axios";
import { url } from "../../utils/url";

const Cars = ({ setCarId }) => {
  const [cars, setCars] = useState([]);
  const [car, setCar] = useState("");

  useEffect(() => {
    (async () => {
      const request = await axios.get(`${url}vehicles?isActive=true`, { withCredentials: true });
      setCars(request.data);
    })();
  }, []);

  return (
    <FormControl sx={{ width: "200px" }}>
      <InputLabel id="car-select">Избор на кола</InputLabel>
      <Select labelId="car-select" id="demo-simple-select" value={car} label="Избор на кола" onChange={(e) => setCar(e.target.value)}>
        {cars.map((car) => (
          <MenuItem key={car.id} value={car.regNumber} onClick={() => setCarId(car.id)}>
            {car.regNumber}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Cars;
